// A candidate's role lives in `mainRole` (Profile page) or, for candidates who
// only completed onboarding, in `primaryRole`. Read paths use this so both show.
export const getCandidateRole = (candidate) =>
  candidate?.mainRole || candidate?.primaryRole || "";
